import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderChildren } from '../helpers';

const ClickWrapper = ({ children, gtmChildren, id, ...props }) => {
  const [clickState, setClickState] = useState(false);
  const renderedChildren = clickState
    ? renderChildren(gtmChildren, {
        clickState,
        clickId: id,
        componentProps: { ...props }
      })
    : null;

  return (
    <div
      role="button"
      onClick={() => {
        setClickState(true);
      }}>
      {renderedChildren}
      {children}
    </div>
  );
};

ClickWrapper.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  gtmChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

ClickWrapper.defaultProps = {
  id: null,
  children: [],
  gtmChildren: []
};

export default ClickWrapper;
